import { CateringTranslations } from "./catering-pt-br";

export const CATERING_EN_US: CateringTranslations = {
	title: "Catering",
	description:
		"Manage your events catering, receive proposals, send quotes and monitor everything in one place.",
	tabs: {
		proposals: "Proposals",
		settings: "Settings",
	},
	settingsMenu: {
		proposalOptions: "Proposal Options",
		servicesAndFormats: "Services and formats",
	},
	feedback: {
		saveSuccess: "Changes saved. They will apply to new proposals.",
		saveError: "Could not save the changes. Please try again in a few moments.",
	},
	proposalOptions: {
		style: {
			title: "Proposal style",
			description: "Personalize your proposal with your company's identity.",
		},
		company: {
			label: "About the company",
			companyLabel: "Company",
			editAria: "Edit company data",
		},
		infoBlocks: {
			label: "Default info blocks",
			showLabel: "Show",
			editAria: "Edit {{name}}",
			disabledHint: "Register the company data before configuring this block.",
			header: "Header",
			footer: "Footer",
			payment: "Payment methods and conditions",
		},
		templates: {
			title: "Saved proposal templates",
			description: "Manage and edit your template proposals.",
			addLabel: "Add template",
			emptyMessage: "No template registered",
			createdAt: "Created on {{date}}",
			editAria: "Edit {{name}}",
		},
	},
	editHeader: {
		title: "Customize header",
		createTitle: "Create header",
		saveLabel: "Save style",
		fields: {
			title: {
				label: "Title",
				placeholder: "E.g.: Commercial Proposal",
			},
			showSubmissionDate: "Show submission date and location",
			showCompanyName: "Show requesting company name",
			showRepresentativeName: "Show company representative name",
			text: {
				label: "Opening text",
				placeholder:
					"E.g.: Dear customers, below is the commercial proposal according to the event schedule.",
				counter: "{{count}}/{{max}} characters",
			},
		},
	},
	editFooter: {
		title: "Customize footer",
		createTitle: "Create footer",
		saveLabel: "Save style",
		fields: {
			text: {
				label: "Closing text",
				placeholder:
					"E.g.: Thank you for your interest. We are available for any questions.",
				counter: "{{count}}/{{max}} characters",
			},
			showResponsibleName: "Show name of proposal sender",
			showProposalValidity: "Show proposal validity",
		},
	},
	editPayment: {
		title: "Customize payment methods and terms",
		createTitle: "Create payment methods and terms",
		saveLabel: "Save style",
		methods: {
			creditCard: "Credit card",
			debitCard: "Debit card",
			boleto: "Bank slip",
			pix: "PIX",
			cash: "Cash",
		},
		fields: {
			methods: {
				label: "Accepted payment methods",
			},
			text: {
				label: "Payment terms",
				placeholder:
					"E.g.: 70% payment on proposal closing and 30% up to 120 hours before the event;",
				counter: "{{count}}/{{max}} characters",
			},
		},
	},
	editCompany: {
		title: "Edit information",
		createTitle: "Create information",
		saveLabel: "Save information",
		errors: {
			invalidEmail: "Invalid email",
			invalidUrl: "Invalid link",
			requiredName: "Enter the company name",
		},
		sections: {
			info: "Company information",
			contacts: "Contact channels",
			address: "Address",
		},
		fields: {
			name: {
				label: "Name",
				placeholder: "Type the company name",
			},
			cnpj: {
				label: "Tax ID",
				placeholder: "00.000.000/0000-00",
			},
			site: {
				label: "Website",
				placeholder: "Paste the website URL",
			},
			logo: {
				label: "Brand",
				cta: "Add logo",
				help: "JPG or PNG file with 300x105px.",
			},
			primaryColor: {
				label: "Primary color",
				help: "Pick the color applied on icons, text and buttons.",
				placeholder: "#000000",
			},
			mainPhone: {
				label: "Primary phone",
				placeholder: "+1 (555) 000-0000",
			},
			secondaryPhone: {
				label: "Secondary phone",
				placeholder: "+1 (555) 000-0000",
			},
			whatsapp: {
				label: "WhatsApp",
				placeholder: "whatsapp.we/9128394",
			},
			email: {
				label: "Email",
				placeholder: "contact@company.com",
			},
			socialMedia: {
				label: "Social media",
				placeholder: "instagram/company",
			},
			zipCode: {
				label: "ZIP code",
				placeholder: "Type the ZIP code",
			},
			street: {
				label: "Address",
				placeholder: "Street, avenue or place",
			},
			number: {
				label: "Number",
				placeholder: "Number",
			},
			complement: {
				label: "Complement",
				placeholder: "Complement",
			},
		},
	},
	proposalList: {
		filters: {
			searchPlaceholder: "Search proposals",
			statusPlaceholder: "All statuses",
			placePlaceholder: "All places",
		},
		columns: {
			representative: "Company representative",
			place: "Place",
			sentBy: "Sent by",
			startsAt: "Starts at",
			servicesCount: "Services",
			servicesTotal: "Amount",
			status: "Status",
		},
		status: {
			accepted: "Accepted",
			newResponse: "New response",
			draft: "Draft",
			sent: "Sent",
			sendFailed: "Send failed",
			rejected: "Rejected",
		},
		emptyMessage: "No proposals found",
	},
	servicesAndFormats: {
		itemsCount: {
			one: "{{count}} item",
			other: "{{count}} items",
		},
		drawerHelperText: "Press Enter to add to the list.",
		services: {
			title: "Registered services",
			description: "Manage and register services to use when creating proposals.",
			addLabel: "Add service",
			emptyMessage: "No service registered",
			drawer: {
				title: "Add new service",
				inputLabel: "Service name",
				inputPlaceholder: "Type the name of the new service",
				saveLabel: "Save service",
			},
			notifications: {
				created: "Service(s) created successfully.",
				createdPartial: "{{ok}} service(s) created, {{failed}} failed.",
				createFailed: "Could not create services.",
				deleted: "Service removed successfully.",
				deleteFailed: "Could not remove service.",
			},
		},
		formats: {
			title: "Registered formats",
			description: "Manage and register formats to use when creating proposals.",
			addLabel: "Add format",
			emptyMessage: "No format registered",
			drawer: {
				title: "Add new format",
				inputLabel: "Format name",
				inputPlaceholder: "Type the name of the new format",
				saveLabel: "Save format",
			},
			notifications: {
				created: "Format(s) created successfully.",
				createdPartial: "{{ok}} format(s) created, {{failed}} failed.",
				createFailed: "Could not create formats.",
				deleted: "Format removed successfully.",
				deleteFailed: "Could not remove format.",
			},
		},
	},
};
